import moment from "moment";
import {deepClone} from './copyObject';
import {kpiBasedType,kpisMapping} from './constants';

// Get agreegate kpi data for chart preview
export const getAgreegateKpisData = (data) => { 
    let {kpiAgreegateData,kpiRecords,kpiType} = deepClone(data);
    if(kpiRecords) {
        kpiRecords = kpiRecords.filter(kpiRecord => kpiRecord.selected);
    }
    if((kpiAgreegateData && kpiAgreegateData.length > 0) && kpiType === kpiBasedType.empDataBased) {
        let kpiData = kpiRecords.map((kpiRecord, kpiRecordIndex) => {
            // if(kpiRecord.selected) {
                console.log('kpiRecord ---- ', kpiRecord)
                let location;
                if(kpiRecord.selectedLocation.state!==null) {
                    let {id, name} = kpiRecord.selectedLocation.state;
                     location = {key: id, values: name, country: kpiRecord.selectedLocation.country.name};
                  }else {
                      location = {key: 'ALL'};
                  }
                let diversityType = kpiRecord.gender ? kpiRecord.gender.id : 'FEMALE';
                
                let kpiId = {id: kpiRecord.selectedKPI.id, name: kpiRecord.selectedKPI.name, description: kpiRecord.selectedKPI.description,refObject:kpiRecord.selectedKPI};
                let kpiCode = kpiRecord.selectedKPI.code;
                let occupationId = kpiRecord.occupation ? {name: kpiRecord.occupation.name} : null;
                let seniorityId = kpiRecord.seniority ? {name: kpiRecord.seniority.name}: null;

                let kpiScore = kpiAgreegateData.map((kpiAgreegate, kpiAgreegateIndex) => {
                    console.log('kpiAgreegate --- ', kpiAgreegate)
                    let kpiScores = [];
                    if(kpiRecordIndex === kpiAgreegateIndex && kpiAgreegate[kpiCode]){
                        kpiScores = kpiAgreegate[kpiCode].map(kpiScore => {
                            // console.log(kpiScore,kpiScore.data)

                            let avgTenure = false

                            if(kpiScore && kpiScore.docs && kpiScore.docs.avgTenure >= 0){
                                avgTenure=kpiScore.docs.avgTenure
                            }else if(kpiScore && kpiScore.avgTenure >= 0){
                                avgTenure=kpiScore.avgTenure
                            }
                            
                            if(kpiScore.data && kpiScore.data.numeratorType) {
                                return {
                                    kpiCode, 
                                    ethnicity: kpiScore.ethnicityType, 
                                    value: kpiScore.score, 
                                    date: kpiScore.isoDate, 
                                    totalEmployees: kpiScore.data.totalEmployees, 
                                    data:kpiScore.data,
                                    avgTenure
                                }
                            } else {
                                return {kpiCode, value: kpiScore.score, date: kpiScore.isoDate, avgTenure}
                            }
                            
                    })}
                    if(kpiScores.length>0) {
                        return [...kpiScores];
                    }    

                })
                kpiScore = kpiScore.filter(score => score);
                let selectedKPIData = {kpiId: kpiId, score: kpiScore[0], diversityType, location};
                if (occupationId !== null && occupationId!== 'ALL') {
                    selectedKPIData['occupationId'] = occupationId;
                }
                if (seniorityId !== null && seniorityId!== 'ALL'){
                    selectedKPIData['seniorityId'] = seniorityId;
                }
                return selectedKPIData;
            // }
        })
        kpiData = kpiData.filter(kpi => kpi);
        return kpiData;
      } else if((kpiAgreegateData && kpiAgreegateData.length > 0) && kpiType === kpiBasedType.surveyBased) {
        let surveyKpiData = kpiRecords.map(kpiRecord => {
            if(kpiRecord.selected) {
                let kpiId = {id: kpiRecord.selectedKPI.id, name: kpiRecord.selectedKPI.name, description: kpiRecord.selectedKPI.description};
                let kpiCode = kpiRecord.selectedKPI.code;
                let scores = [];
                scores = kpiAgreegateData.map(kpiAgreegate => {
                    let surveyScore = [];
                    if(kpiAgreegate[kpiCode]){
                            surveyScore = kpiAgreegate[kpiCode].map(kpiScore => {
                            return {value: kpiScore.score, date: kpiScore.selectedDate}
                    })
                    }
                    if(surveyScore.length>0)
                      return [...surveyScore];
                });
               let kpiInputs = kpiAgreegateData.map(kpiAgreegate => {
                    let surveyScore = [];
                    if(kpiAgreegate[kpiCode]){
                    surveyScore = kpiAgreegate[kpiCode].map(kpiScore => kpiScore.kpiInputs[0]);
                    }
                    if(surveyScore.length>0)
                      return {...surveyScore[0]};
                });
                scores = scores.filter(kpiScore => kpiScore);
                kpiInputs = kpiInputs.filter(kpiInput => kpiInput);
                let selectedKPIData = {kpiId: kpiId, score: scores[0], kpiInputs};
                // console.log('selectedKPIData',selectedKPIData);
                return selectedKPIData;
            }
        });
        surveyKpiData = surveyKpiData.filter(kpi => kpi);
        return surveyKpiData;
      } else {
        return [];
      }
      
}

// Get Benchmark data for chart preview
export const getBenchmarkData = (data, enableFilterDate, dateRangeDetails) => {
    let {startDate, endDate, useLatestDataAvailable} = dateRangeDetails;
    // console.log("d--- ", data)
    let {kpiAgreegateData, selectedBenchmark} = deepClone(data);
    // console.log('b--', selectedBenchmark)
    if(selectedBenchmark && selectedBenchmark!==null && selectedBenchmark.length>0 && kpiAgreegateData.length === 1) {
        // let benchmarkType = selectedBenchmark.key;
        let benchmarkScores = [];  
        benchmarkScores = selectedBenchmark[0].map(benchmark => {
            // console.log('b--', benchmark)
            return benchmark.trend.map(trend => {
                return{date: trend.date, value: trend.score};
            })
        });
        benchmarkScores = [].concat.apply([], benchmarkScores);
        // console.log('scores--', benchmarkScores)
        if (enableFilterDate) {
            benchmarkScores = benchmarkScores.filter(score => {
                if (startDate !== null && endDate !== null && !useLatestDataAvailable) {
                    return moment(score.date) > moment(startDate) && moment(score.date) < moment(endDate);
                } else if (startDate !== null && !useLatestDataAvailable) {
                    return moment(score.date) > moment(startDate);
                } else if (startDate !== null && useLatestDataAvailable) {
                    return moment(score.date) > moment(startDate) && moment(score.date) < moment(new Date());
                } else {
                    return true;
                }
            })
        }
        return {score: benchmarkScores};
      }
}



export const filterRawBenchmarkData = (benchmarkData) => {
    // console.log(benchmarkData)
    // console.log("here")
    if(!benchmarkData){
        return [];
    }
    else if (benchmarkData && benchmarkData.length === 0) {
        return [];
    } else {
        return benchmarkData.map(benchmark => {
            // console.log("ben filter -- ", benchmark.docs)
             let c = benchmark.docs.filter(doc => doc.trend.length > 0);
            //  console.log(c)
             return benchmark.docs.filter(doc => doc.trend.length > 0);

        })
    }
}

export const filterBenchmarkByState = (benchmarkData, state) => {
    if(!benchmarkData){
        return [];
    }
    else if (benchmarkData && benchmarkData.length === 0) {
        return [];
    } else {
        if (!state || state === null) {
            return benchmarkData;
        } else {
            return benchmarkData.map(benchmark => {
                // console.log(benchmark)
                return benchmark.filter(doc => {
                    // location doesnt exist
                    // console.log(doc)
                    if(!doc.location){
                        return false;
                    } else {
                        return doc.location.toLowerCase() === state.toLowerCase();
                    }
                })
            })
        }

    }
}

export const filterBenchmarkByDateAndState = (benchmarkData, state, startDate, endDate, useLatestDataAvailable) => {
    if(!benchmarkData){
        return [];
    }
    else if (benchmarkData && benchmarkData.length === 0) {
        return [];
    } else {
        benchmarkData.map(benchmark => {
            return benchmark.filter(doc => doc.location === state);
        })
    }
}

export const filterBenchmarkData = (data, enableFilterDate, dateRangeDetails) => {
    let {startDate, endDate, useLatestDataAvailable} = dateRangeDetails;
    let {kpiAgreegateData, selectedBenchmark} = deepClone(data);
    if(selectedBenchmark && selectedBenchmark!==null && selectedBenchmark.data.length>0 && kpiAgreegateData.length === 1) {
        let benchmarkType = selectedBenchmark.key;
        let benchmarkScores = [];  
        benchmarkScores = selectedBenchmark.data[0].docs.map(benchmark => {
            return{date: benchmark.date, value: benchmark.score};
        })
        // if (enableFilterDate) {
        //     benchmarkScores = benchmarkScores.filter(score => {
        //         if (startDate !== null && endDate !== null && !useLatestDataAvailable) {
        //             return moment(score.date) > moment(startDate) && moment(score.date) < moment(endDate);
        //         } else if (startDate !== null && !useLatestDataAvailable) {
        //             return moment(score.date) > moment(startDate);
        //         } else if (startDate !== null && useLatestDataAvailable) {
        //             return moment(score.date) > moment(startDate) && moment(score.date) < moment(new Date());
        //         } else {
        //             return true;
        //         }
        //     })
        // }
        return {benchmarkType: benchmarkType, score: benchmarkScores};
      }
}

// export const isKpiDataAvailebleinDateRange = (kpiAgreegate,startDate,endDate,useLatestDataAvailable) => {
//     if (startDate !== null && endDate !== null && !useLatestDataAvailable) {
//         return moment(kpiAgreegate.date) > moment(startDate) && moment(kpiAgreegate.date) < moment(endDate);
//     } else if (startDate !== null && !useLatestDataAvailable) {
//         return moment(kpiAgreegate.date) > moment(startDate);
//     } else if (startDate !== null && useLatestDataAvailable) {
//         return moment(kpiAgreegate.date) > moment(startDate) && moment(kpiAgreegate.date) < moment(new Date());
//     } else {
//         return true;
//     }
// }


export const getGenderLists = (orgMapping) => {
    let maleList = [];
    let femaleList = [];
    let otherList = [];
    let pntsList = [];
    let nBnList = [];
    // orgMapping may be the unloaded initial state ([]) — degrade to empty lists, never throw
    let genderData = (orgMapping && !Array.isArray(orgMapping) && orgMapping.gender && Array.isArray(orgMapping.gender.data))
        ? orgMapping.gender.data : [];
    let filteredMaleList =  genderData.filter(gender => gender.key === 'MALE');
    let filteredFemaleList =  genderData.filter(gender => gender.key === 'FEMALE');
    let filteredOtherGenderList =  genderData.filter(gender => gender.key === 'OTHER');
    let filteredPntsList = genderData.filter(gender => gender.key === "Prefer not to specify");
    let filteredNbnList = genderData.filter(gender => gender.key === "NON-BINARY");
   
    if(filteredMaleList.length > 0) {
      maleList = filteredMaleList[0].values;
    }
    if(filteredFemaleList.length > 0) {
      femaleList = filteredFemaleList[0].values;
    }
    if(filteredOtherGenderList.length > 0) {
      otherList = filteredOtherGenderList[0].values;
    }
    if(filteredPntsList.length>0){
        pntsList = filteredPntsList[0].values;
    }
    if(filteredNbnList.length>0){
        nBnList = filteredNbnList[0].values;
    }
    return {maleList, femaleList, otherList, pntsList, nBnList};
  }

  export const createKPIAgreegateRequestData = (kpiRecord, orgMapping) => {
    // let {occupationOptions, seniorityOptions} = orgMapping
    console.log(kpiRecord)
    let diversityGrpString=[]
    let code = kpiRecord.selectedKPI.code;
    let occupationList = kpiRecord.occupation!==null ? kpiRecord.occupation.values : [];
    let occupationCode = kpiRecord.occupation!==null ? kpiRecord.occupation.code : 'NONE';
    let seniorityList = kpiRecord.seniority!==null ? kpiRecord.seniority.values : [];
    let seniorityCode = kpiRecord.seniority!==null ? kpiRecord.seniority.code : 'NONE';
    let performanceList = (kpiRecord.performance && kpiRecord.performance!==null) ? kpiRecord.performance.values : [];
    let separationList = (kpiRecord.separation && kpiRecord.separation!==null) ? kpiRecord.separation.values : [];
   
    

    let diversityType, ethnicityType,  ethnicityList=[], veteranType,ageStart, ageEnd,
        veteranList=[],sexualOrientationType, sexualOrientationList=[],
        religionType, religionList=[], disabilityType, disabilityList=[], location


    // if(kpiRecord.ageStart!=null){
    //     diversityGrpString.push(kpiRecord.ageStart.id)
    //     ageStart = kpiRecord.ageStart.id
    // }

    // if(kpiRecord.ageEnd!=null){
    //     diversityGrpString.push(kpiRecord.ageEnd.id)
    //     ageEnd = kpiRecord.ageEnd.id
    // }


    if(kpiRecord.gender!==null && kpiRecord.gender.id!=null){
        // diversityType=kpiRecord.gender.name
// 
        diversityType=kpiRecord.gender.id
        diversityGrpString.push(diversityType)
    }
    // else {
    //     diversityType=null
    // }
    
    if(kpiRecord.veteran!==null){
        veteranType=kpiRecord.veteran.name
        diversityGrpString.push(veteranType)
        veteranList = kpiRecord.veteran!==null ? kpiRecord.veteran.values : [];
    }

    if(kpiRecord.ethnicity!==null){
        ethnicityType=kpiRecord.ethnicity.name
        ethnicityList = kpiRecord.ethnicity.values 
        diversityGrpString.push(ethnicityType)
    } 
   

    if(kpiRecord.sexualOrientation!==null){
        sexualOrientationType=kpiRecord.sexualOrientation.name
        sexualOrientationList= kpiRecord.sexualOrientation.values 
        diversityGrpString.push(sexualOrientationType)

    }

    if(kpiRecord.disability!==null){
        disabilityType=kpiRecord.disability.name
        disabilityList= kpiRecord.disability.values 
        diversityGrpString.push(disabilityType)
    }
    
    if(kpiRecord.religion!==null){
        religionType=kpiRecord.religion.name
        religionList= kpiRecord.religion.values 
        diversityGrpString.push(religionType)
    }
    

    if(kpiRecord.selectedLocation.state!==null) {
      let {id, name} = kpiRecord.selectedLocation.state;
       location = {key: id, values: [id,name], country: kpiRecord.selectedLocation.country.name};
    }else {
        location = {key: 'ALL'};
    }


    if(kpiRecord.ageStart!=null&&kpiRecord.ageEnd!=null){
        ageStart = kpiRecord.ageStart.id?kpiRecord.ageStart.id:kpiRecord.ageStart
        ageEnd = kpiRecord.ageEnd.id?kpiRecord.ageEnd.id:kpiRecord.ageEnd
        diversityGrpString.push(`${ageStart}-${ageEnd}`)
    } else if(kpiRecord.ageStart!=null){
        ageStart = kpiRecord.ageStart.id?kpiRecord.ageStart.id:kpiRecord.ageStart
        diversityGrpString.push(`${ageStart}`)
    } else if(kpiRecord.ageEnd!=null){
        ageEnd = kpiRecord.ageEnd.id?kpiRecord.ageEnd.id:kpiRecord.ageEnd
        diversityGrpString.push(`${ageEnd}`)
    }


    let kpiObject = {
        tenure: kpiRecord.tenure,
        ageEnd, ageStart,
        code,ethnicityList,ethnicityType, veteranList, veteranType,
        sexualOrientationList, sexualOrientationType, religionType, 
        religionList, disabilityList, disabilityType,
        occupationCode, occupationList, occupationCode, seniorityList, 
        seniorityCode, diversityType, location, diversityGrpString
    };

    if (performanceList.length > 0){
        kpiObject['performanceList'] = performanceList;
    } else if (separationList.length > 0) { 
        kpiObject['separationList'] = separationList;
    }

    return kpiObject
} 


export const createKPIAgreegateRequestDataRefreshChart = (kpiRecord, orgMapping, allOccupationValues, allSeniorityValues) => {
    let {occupation, performance, seniority, separation, ethnicity, disability, veteran, religion, sexualOrientation} = orgMapping;
    console.log(kpiRecord)
    // console.log(orgMapping)
    let code = kpiRecord.kpiId && kpiRecord.kpiId.code ? kpiRecord.kpiId.code : '';

    
    let occupationCode = 'NONE';
    let ethnicityType, veteranType, sexualOrientationType, religionType, disabilityType
    let ethnicityList=[], veteranList=[], sexualOrientationList=[], 
    religionList=[], disabilityList=[],occupationList = [], seniorityList = [];
    let seniorityCode = 'NONE';
    let diversityType = '';
    let ageStart, ageEnd;
    let location = kpiRecord.location;
    if(kpiRecord.diversityType) {
        diversityType = kpiRecord.diversityType;
    }

    if(kpiRecord.ageStart){
        if(kpiRecord.ageStart.id){
            ageStart=kpiRecord.ageStart.id
        }else if(kpiRecord.ageStart){
            ageStart=kpiRecord.ageStart
        }
    }

    if(kpiRecord.ageEnd){
        if(kpiRecord.ageEnd.id){
            ageEnd = kpiRecord.ageEnd.id
        }else if(kpiRecord.ageEnd){
            ageEnd = kpiRecord.ageEnd
        }
    }
    

    if(kpiRecord.occupationId && occupation && occupation.data) {
        let filteredOccupation = occupation.data.filter(occupationMapping => occupationMapping.reference._id === kpiRecord.occupationId._id);
            if(filteredOccupation.length>0) {
                occupationCode = filteredOccupation[0].reference.code;
            }
        if(kpiRecord.occupationId.name && kpiRecord.occupationId.name.toLowerCase()==='all'){
            occupationList = allOccupationValues;
        } else if(filteredOccupation.length>0) {
            occupationList = filteredOccupation[0].values;
        }
    }

    if(kpiRecord.ethnicityId && ethnicity && ethnicity.data) {
        let filteredEthnicity = ethnicity.data.filter(ethnicityMapping => ethnicityMapping.reference._id === kpiRecord.ethnicityId._id);
            if(filteredEthnicity.length>0) {
                ethnicityType = filteredEthnicity[0].reference.name;
                ethnicityList = filteredEthnicity[0].values;
            }
    }


    if(kpiRecord.veteranId && veteran && veteran.data) {
        let filteredveteran = veteran.data.filter(veteranMapping => veteranMapping.reference._id === kpiRecord.veteranId._id);
            if(filteredveteran.length>0) {
                veteranType = filteredveteran[0].reference.name;
                veteranList = filteredveteran[0].values;
            }
    }


    if(kpiRecord.sexualOrientationId && sexualOrientation && sexualOrientation.data) {
        let filteredsexualOrientation = sexualOrientation.data.filter(sexualOrientationMapping => sexualOrientationMapping.reference._id === kpiRecord.sexualOrientationId._id);
            if(filteredsexualOrientation.length>0) {
                sexualOrientationType = filteredsexualOrientation[0].reference.name;
                sexualOrientationList = filteredsexualOrientation[0].values;
            }
    }


    if(kpiRecord.religionId && religion && religion.data) {
        let filteredreligion = religion.data.filter(religionMapping => religionMapping.reference._id === kpiRecord.religionId._id);
            if(filteredreligion.length>0) {
                religionType = filteredreligion[0].reference.name;
                religionList = filteredreligion[0].values;
            }
    }


    if(kpiRecord.disabilityId && disability && disability.data) {
        let filtereddisability = disability.data.filter(disabilityMapping => disabilityMapping.reference._id === kpiRecord.disabilityId._id);
            if(filtereddisability.length>0) {
                disabilityType = filtereddisability[0].reference.name;
                disabilityList = filtereddisability[0].values;
            }
    }

    if(kpiRecord.seniorityId && seniority && seniority.data) {
        let filteredSeniority = seniority.data.filter(seniorityMapping => seniorityMapping.reference._id === kpiRecord.seniorityId._id);
            if(filteredSeniority.length>0) {
                seniorityCode = filteredSeniority[0].reference.code;
            }
        if(kpiRecord.seniorityId.name && kpiRecord.seniorityId.name.toLowerCase()==='all'){
            seniorityList = allSeniorityValues;
        } else if(filteredSeniority.length>0) {
            seniorityList = filteredSeniority[0].values;
        }
    }


    let isTenure = false;

    const findDocsTenureExist = kpiRecord.score && kpiRecord.score.find(x => x.avgTenure && x.avgTenure !=null);

    if(findDocsTenureExist){
      isTenure = true
    }

    let kpiObject = {code, 
        tenure: isTenure,
        ethnicityList, ethnicityType, sexualOrientationList,
                    sexualOrientationType, veteranType, veteranList, religionList,
                    religionType, disabilityType,disabilityList,occupationList, 
                    occupationCode, seniorityList, ageEnd, ageStart,
                    seniorityCode, diversityType, location};

    if(kpisMapping[code] && kpisMapping[code].performance){
        let performanceOptions = performance;
        let perfomanceKey = kpisMapping[code].performanceKey;
        if(performanceOptions && performanceOptions.data) {
            let matchedPerfomance = performanceOptions.data.filter(performance => performance.reference.name === perfomanceKey);
            if(matchedPerfomance.length > 0){
                kpiObject['performanceList'] = matchedPerfomance[0].values;
            }else {
                kpiObject['performanceList'] = []
            }
        }
      }

      if(kpisMapping[code] && kpisMapping[code].separation){
        let separationOptions = separation;
        let separationKey = kpisMapping[code].separationKey;
        if(separationOptions && separationOptions.data) {
        let matchedSeparation = separationOptions.data.filter(separation => separation.reference.name === separationKey);
        if(matchedSeparation.length > 0){
            kpiObject['separationList'] = matchedSeparation[0].values;
        } else {
            kpiObject['separationList'] =[]
        }
       }
      }
    return kpiObject;
} 

export const getAllOccupationAndSeniorityValues = (orgMapping) => {
    let allOccupationValues = [], allSeniorityValues = [];
    // orgMapping may be the unloaded initial state ([]) — degrade to empty lists, never throw
    if (!orgMapping || Array.isArray(orgMapping)) {
        return {allOccupationValues, allSeniorityValues};
    }
    let {occupation, seniority} = orgMapping;
    if (occupation && Array.isArray(occupation.data)) {
        allOccupationValues = occupation.data.map(occupationMapping => occupationMapping.value);
        allOccupationValues = [].concat.apply([], allOccupationValues);
    }
    if (seniority && Array.isArray(seniority.data)) {
        allSeniorityValues = seniority.data.map(seniorityMapping => seniorityMapping.value);
        allSeniorityValues = [].concat.apply([], allSeniorityValues);
    }
    return {allOccupationValues, allSeniorityValues};
}




export const getFormattedType = (mapType) => {
    let allMapTypeValues=[]
    mapType = mapType.data.map(mapTypeMapping => {
        allMapTypeValues = [...allMapTypeValues, mapTypeMapping.values];
        let name = mapTypeMapping.reference.name?mapTypeMapping.reference.name:mapTypeMapping.key
        return { id: mapTypeMapping.reference._id, name, code: mapTypeMapping.reference.code, values: mapTypeMapping.values, definition: mapTypeMapping.reference.definition,refObject:mapTypeMapping.reference}
      })
    allMapTypeValues = [].concat.apply([], allMapTypeValues);
    let allMapTypeRecord = mapType.filter(mapType => mapType.name === 'All' || mapType.name === 'ALL');
    allMapTypeRecord = {...allMapTypeRecord[0], values: allMapTypeValues};
    let otherMapTypeRecords = mapType.filter(mapType => mapType.name !== 'All' && mapType.name !== 'ALL');

    return [allMapTypeRecord, ...otherMapTypeRecords];
}



  export const getFormattedMappingData = (mapping) => {
    //   console.log(mapping)
    let {gender, religion, birthDate, disability, veteran, sexualOrientation, occupation, seniority, performance, separation, ethnicity} = mapping;
    // let allOccupationValues = [], allSeniorityValues = [], allEthnicityValues=[]
    if (occupation.data && occupation.data.length === 0) {
      occupation = [];
    } else {
        occupation  = getFormattedType(occupation)
    }

    if (sexualOrientation && sexualOrientation.data && sexualOrientation.data.length === 0 || sexualOrientation===undefined) {
        sexualOrientation = [];
    } else {
        sexualOrientation  = getFormattedType(sexualOrientation)
    }

    if (veteran && veteran.data && veteran.data.length === 0 || veteran===undefined) {
        veteran = [];
    } else {
        veteran  = getFormattedType(veteran)
    }
    
    if (disability && disability.data && disability.data.length === 0 || disability===undefined) {
        disability = [];
    } else {
        disability  = getFormattedType(disability)
    }

    if (birthDate && birthDate.data && birthDate.data.length === 0 || birthDate===undefined) {
        birthDate = [];
    } else {
        birthDate  = getFormattedType(birthDate)
    }

    if (religion && religion.data && religion.data.length === 0 || religion===undefined) {
        religion = [];
    } else {
        religion  = getFormattedType(religion)
    }

    if (ethnicity.data && ethnicity.data.length === 0) {
        ethnicity = [];
    } else {
        ethnicity  = getFormattedType(ethnicity)
    }

    if (seniority.data && seniority.data.length === 0) {
      seniority = [];
    } else {
        seniority  = getFormattedType(seniority)
    }

    if (performance.data && performance.data.length === 0) {
      performance = [];
    } else {
      performance = performance.data.map(performanceMapping => {
        return { id: performanceMapping.reference._id, name: performanceMapping.key, values: performanceMapping.values };
      });
    }

    if (separation.data && separation.data.length === 0) {
        separation = [];
      } else {
        separation = separation.data.map(separationMapping => {
          return { id: separationMapping.reference._id, name: separationMapping.key, values: separationMapping.values };
        });
      }

    return {gender, occupation, seniority, disability, birthDate, performance, separation, ethnicity, sexualOrientation, veteran, religion};
  } 